import * as React from 'react';
import { Alert } from 'rcd-cpp-ui/ui/alert/Alert';
import { getSchema } from '../../../utils';
import { SchemaField } from '../../../../../Webapp/src/types/Metadata';
import { useSelector } from '../../../utils/useSelector';
import { RequiredFiltersError } from './requiredFiltersError';
export const Info = () => {
  const dataType = useSelector(s => {
    const data = s.view?.selected?.card?.props?.data;
    let dataType: string = data;
    if (data) {
      const schema = getSchema(s.planning?.selectedWorkspace?.schemas, data);
      if (schema) dataType = schema.props?.name || data;
    }
    return dataType;
  });
  const info = useSelector(s => s.view?.info);
  if (!info) return null;
  const {
    invalidSwimlaneCategory,
    missingSwimlaneCategory,
    missingRequiredFilters,
    unusedFilters,
    invalidSortFields
  } = info;
  const renderSortInfo = (invalidSortFields: SchemaField[]) => {
    if (!invalidSortFields?.length) {
      return;
    } else if (invalidSortFields.length == 1) {
      return (
        <div>
          Selected Sort Criterion is invalid because there is no association
          between the <b>{invalidSortFields[0]}</b> field and&nbsp;
          <b>{dataType}</b>.
        </div>
      );
    } else {
      return (
        <div>
          Following sort criteria are not being used because there is no
          association between the criteria and <b>{dataType}</b>.
          <b>{invalidSortFields.join(', ')}</b>
        </div>
      );
    }
  };
  return (
    <div>
      {!!unusedFilters?.length && (
        <Alert type="warning">
          <div>
            Following filters were not being used because there is no
            association between the filters and <b>{dataType}</b>.
          </div>
          <b>{unusedFilters.map(f => f.displayName).join(', ')}</b>
        </Alert>
      )}
      {invalidSwimlaneCategory && (
        <Alert type="error">
          Selected Board Category is invalid because there is no association
          between the <b>{info.invalidSwimlaneCategory}</b> and&nbsp;
          <b>{dataType}</b>.
        </Alert>
      )}
      {missingSwimlaneCategory && (
        <Alert type="error">Board Category is missing or invalid.</Alert>
      )}
      {invalidSortFields?.length > 0 && (
        <Alert type="error">{renderSortInfo(invalidSortFields)}</Alert>
      )}
      {missingRequiredFilters?.length > 0 && (
        <RequiredFiltersError fields={missingRequiredFilters} />
      )}
    </div>
  );
};
